import { useTranslation } from "react-i18next";
import TeambookDialog from "./TeambookDialog";
import PropTypes from "prop-types";

const TeambookDialogYesNo = ({ open, setOpen, question, questionTitle, yesCallback, noCallback }) => {
  const { t } = useTranslation();

  const noButtonClicked = () => {
    noCallback();
    setOpen(false);
  };

  const yesButtonClicked = () => {
    yesCallback();
    setOpen(false);
  };

  return (
    <TeambookDialog
      onClose={() => setOpen(false)}
      open={open}
      title={questionTitle}
      withCloseButton
      content={
        <p style={{marginBottom: 0}}>{question}</p>
      }
      actionButtons={[
        {
          text: t("no"),
          onClick: noButtonClicked,
          type: "outlined",
        },
        {
          text: t("yes"),
          onClick: yesButtonClicked,
        },
      ]}
    />
  );
};

TeambookDialogYesNo.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  question: PropTypes.string,
  questionTitle: PropTypes.string,
  yesCallback: PropTypes.func,
  noCallback: PropTypes.func,
};

export default TeambookDialogYesNo;
